import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { BroadcastNewPage } from '@/features/marketing'

export const Route = createFileRoute('/_authenticated/marketing/broadcast/new')(
  {
    component: () => (
      <RequirePermission permission='marketing.create'>
        <BroadcastNewPage />
      </RequirePermission>
    ),
  }
)
